module.exports = __webpack_public_path__ + "img/inqom.23862c83.png";